import { Trans } from "@lingui/macro";
import { ApiEpUsers, IApiEpUser } from "@smp/api";
import { UiButton, UiTypography } from "@smp/ui";
import { useSnackbar } from "notistack";
import { useState } from "react";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { useFailureTranslator } from "@/hooks/use_failure_translator";

import { Notification } from "../_shared/notification";

export const NotificationEmailVerify = ({
  me,
  onClose,
}: {
  me: IApiEpUser;
  onClose: () => void;
}) => {
  const { failureTranslationGet } = useFailureTranslator();
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEmailVerifyRequest = async () => {
    setIsLoading(true);
    try {
      await ApiEpUsers.common.emailVerifyRequest();
      enqueueSnackbar(
        <Trans>
          An email with a confirmation link has been sent to {me.email}
        </Trans>,
        { variant: "success" },
      );
    } catch (failureApi) {
      enqueueSnackbar(failureTranslationGet(failureApi), {
        variant: "error",
      });
    }
    setIsLoading(false);
  };

  return (
    <Notification
      actions={
        <>
          <UiButton
            color="primary"
            gutterRight
            isLoading={isLoading}
            onClick={handleEmailVerifyRequest}
            size="small"
            variant="contained"
          >
            <Trans>Send confirmation</Trans>
          </UiButton>
          <UiButton
            color="primary"
            component={HelperAdapterLink}
            onClick={onClose}
            size="small"
            to="/settings/email"
            variant="semifilled"
          >
            <Trans>Change E-mail Address</Trans>
          </UiButton>
        </>
      }
      body={
        <UiTypography>
          <Trans>
            You may lose access to your account. Please confirm your e-mail
            address {me?.email}
          </Trans>
        </UiTypography>
      }
      level="warning"
    />
  );
};
